import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrompt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"prompt, scan-text"} maskId="square-filled-radius-0-stroke-1-IconPrompt"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H7V5H3V9H2V4ZM17 4H22V9H21V5H17V4ZM7 9H17V10H7V9ZM7 14H15V15H7V14ZM3 15V19H7V20H2V15H3ZM22 15V20H17V19H21V15H22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPrompt;
